import Vue from "vue";
import vueFilters from "./vue-filters";
import find from "lodash/find";
import debounce from "lodash/debounce";
import map from "lodash/map";
import filter from "lodash/filter";
import size from "lodash/size";
import vSelect from "vue-select";
import VueTippy, { TippyComponent } from "vue-tippy";

const fontSizeStep = 2;
const positionStep = 8;
const pollingRate = 100;

var changeCount = 0;

export default function init() {
    var el = document.getElementById("product-app");
    if (!el) return;
    var token = el.getAttribute("data-token");
    var productData = el.getAttribute("data-product-data");

    Vue.component("v-select", vSelect);
    Vue.use(VueTippy);
    Vue.component("tippy", TippyComponent);

    window.onbeforeunload = function () {
        if (changeCount > 1) return "Do you really want to leave this product?";
    };

    var app = new Vue({
        el: el,
        delimiters: ["${", "}"],
        filters: vueFilters,
        data: {
            OpenIndicator: {
                render: (createElement) => createElement("span", { class: { toggle: true } }),
            },
            loading: true,
            polling: false,
            personalisable: false,
            count: 1,
            sides: [],
            extras: {},
            fonts: [{ title: "Open sans", fontId: "Open+Sans" }],
            productRemark: "",
            productImageActive: true,
            productColors: [],
            printColors: [],
            activeProduct: false,
            activeSideIndex: 0,
            activeVariantId: 0,
            activeProductColorIndex: 0,
            sideModalOpen: false,
        },
        created: function () {
            let staticThumbs = document.querySelectorAll(".product-thumbnails__item--static");
            let dynamicThumb = document.querySelector(".product-thumbnails__item--dynamic");

            Array.from(staticThumbs).forEach((el) => {
                el.parentNode.removeChild(el);
            });

            if (dynamicThumb) {
                dynamicThumb.classList.remove("product-thumbnails__item--dynamic");
            }

            this.productColors = window.data.productColors;
            this.printColors = window.data.printColors;
            this.fonts = window.data.fonts;
            this.sides = window.data.sides;
            this.extras = window.data.extras;
            this.personalisable = window.data.personalisable;
            this.defaultVariantId = window.data.defaultVariantId;
            this.variants = window.data.variants;
            this.productImage = window.data.productImage;
            this.productRemark = window.data.productRemark;
            this.sides.forEach((s) => {
                // add reactive property
                Vue.set(s, "activePrintColor", this.printColors[0]);

                if (s.blockColorsImages.length) {
                    var pz = s.blockPrintZone.split(",");
                    s.blockPrintZone = {
                        x: (parseFloat(pz[0]) / 100) * s.blockColorsImages[0].width,
                        y: (parseFloat(pz[1]) / 100) * s.blockColorsImages[0].height,
                        width: (parseFloat(pz[2]) / 100) * s.blockColorsImages[0].width,
                        height: (parseFloat(pz[3]) / 100) * s.blockColorsImages[0].height,
                        middleX:
                            (parseFloat(pz[0]) / 100) * s.blockColorsImages[0].width +
                            ((parseFloat(pz[2]) / 100) * s.blockColorsImages[0].width) / 2,
                        middleY:
                            (parseFloat(pz[1]) / 100) * s.blockColorsImages[0].height +
                            ((parseFloat(pz[3]) / 100) * s.blockColorsImages[0].height) / 2,
                    };

                    Vue.set(s, "showError", false);
                    Vue.set(s, "font1", this.fonts[0]);
                    Vue.set(s, "font2", this.fonts[0]);
                    Vue.set(s, "x", s.blockPrintZone.middleX);
                    Vue.set(s, "y", s.blockPrintZone.middleY);
                    Vue.set(s, "x2", s.blockPrintZone.middleX);
                    var y2 = this.calculateY2(s);
                    Vue.set(s, "y2", y2);
                }
            });
            // activeSideProductColor, the product color of the active side
            this.activeSideProductColor = this.findSideColor(
                this.activeSideIndex,
                this.activeProductColorIndex
            );

            // Get the current active price
            // this.activeProduct = this.findActiveVariant(
            //     this.activeSideIndex,
            //     this.activeProductColorIndex
            // );
        },
        mounted: async function () {
            this.loading = false;
            this.activeVariantId = this.defaultVariantId;
        },
        computed: {
            hasErrors: function () {
                var errors = false;
                this.sides.forEach((s) => {
                    if (s.showError) {
                        errors = true;
                    }
                });
                return errors;
            },
        },
        methods: {
            toggleSideModal: function(openState, e) {
                this.sideModalOpen = openState;
                if(openState) {
                    document.body.classList.add('modal-open');
                } else {
                    document.body.classList.remove('modal-open');
                }
            },
            checkSizeConstraints: function () {
                if( !this.sides.length) return;
                // need to use the real svg elements, not just our saved coords (because of the bounding rectangles)
                var pz = document.getElementById("printZone");
                if (!pz) {
                    // if no printzone, there is no personalisation
                    this.sides[this.activeSideIndex].showError = false;
                    return;
                }
                var text1 = document.getElementById("text1");
                var text2 = document.getElementById("text2");

                var rectText1 = text1.getBoundingClientRect();
                var rectText2 = text2.getBoundingClientRect();
                var rectPz = pz.getBoundingClientRect();

                let result = false;
                // text 1
                if (this.sides[this.activeSideIndex].text1) {
                    if (
                        rectText1.left < rectPz.left ||
                        rectText1.right > rectPz.right ||
                        rectText1.top < rectPz.top ||
                        rectText1.bottom > rectPz.bottom
                    ) {
                        result = true;
                    }
                }
                // text 2
                if (this.sides[this.activeSideIndex].text2) {
                    if (
                        rectText2.left < rectPz.left ||
                        rectText2.right > rectPz.right ||
                        rectText2.top < rectPz.top ||
                        rectText2.bottom > rectPz.bottom
                    ) {
                        result = true;
                    }
                }

                this.sides[this.activeSideIndex].showError = result;
                //console.log("check size constraints", rectText1.left, rectPz.left);
            },
            setProductImageActive: function (e) {
                e.preventDefault();
                this.productImageActive = true;
            },
            setActiveSideIndex: function (e, index) {
                e.preventDefault();
                // clicked a side, so product image is not the active one for sure
                this.productImageActive = false;
                this.activeSideIndex = index;
                this.activeSideProductColor = this.findSideColor(
                    this.activeSideIndex,
                    this.activeProductColorIndex
                );
            },
            // setActiveProductColorIndex: function(e, index) {
            //     e.preventDefault();
            //     this.activeProductColorIndex = index;
            //     this.activeSideProductColor = this.findSideColor(
            //         this.activeSideIndex,
            //         this.activeProductColorIndex
            //     );
            //     // Active product set
            //     this.activeProduct = this.findActiveVariant(
            //         this.activeVariantId,
            //         this.activeProductColorIndex
            //     );
            //     // Look for every available variant
            // },
            setActiveColor: function (id) {
                this.activeProductColorIndex = filter(
                    map(this.productColors, (v, k) => {
                        if (v.id == id) {
                            return "" + k;
                        }
                    }),
                    size
                )[0];
            },
            setActiveVariant: function (id) {
                // this.activeVariantId = parseInt(id);
                this.activeProduct = this.variants.filter((variant) => variant.id == id)[0];
                this.count = 1;
                this.setActiveColor(this.activeProduct.colorId);
            },
            findActiveVariant: function (variantId, colorIndex) {
                const colorId = this.productColors[colorIndex].id;
                const variant = find(this.variants, { id: parseInt(variantId) });
                const title = variant.title;
                return this.variants.filter(
                    (v) => v.title.toLowerCase() == title.toLowerCase() && v.colorId == colorId
                )[0];
            },
            findSideColor: function (sideIndex, colorIndex) {
                var side = this.sides[sideIndex];
                if(!side) return false;
                var color = this.productColors[colorIndex];
                if(!color) return false;
                return (
                    side.blockColorsImages.filter((x) => x.id === color.id)[0] || {
                        itemImageThumbnail: "",
                        width: 0,
                        height: 0,
                    }
                );
            },
            findFirstVariantByColor: function (colorIndex) {
                const colorId = this.productColors[colorIndex].id;
                return this.variants.filter((variant) => variant.colorId == colorId)[0];
            },
            increaseFontSize1: function () {
                this.sides[this.activeSideIndex].fontSize1 += fontSizeStep;
                // var y2 = this.calculateY2(this.sides[this.activeSideIndex]);
                // this.sides[this.activeSideIndex].y2 = y2;
            },
            decreaseFontSize1: function () {
                this.sides[this.activeSideIndex].fontSize1 -= fontSizeStep;
                // var y2 = this.calculateY2(this.sides[this.activeSideIndex]);
                // this.sides[this.activeSideIndex].y2 = y2;
            },
            increaseFontSize2: function () {
                this.sides[this.activeSideIndex].fontSize2 += fontSizeStep;
            },
            decreaseFontSize2: function () {
                this.sides[this.activeSideIndex].fontSize2 -= fontSizeStep;
            },
            increaseX: function () {
                this.sides[this.activeSideIndex].x += positionStep;
            },
            decreaseX: function () {
                this.sides[this.activeSideIndex].x -= positionStep;
            },
            increaseY: function (e) {
                this.sides[this.activeSideIndex].y += positionStep;
                // var y2 = this.calculateY2(this.sides[this.activeSideIndex]);
                // this.sides[this.activeSideIndex].y2 = y2;
            },
            decreaseY: function (e) {
                this.sides[this.activeSideIndex].y -= positionStep;
                // var y2 = this.calculateY2(this.sides[this.activeSideIndex]);
                // this.sides[this.activeSideIndex].y2 = y2;
            },
            increaseX2: function () {
                this.sides[this.activeSideIndex].x2 += positionStep;
            },
            decreaseX2: function () {
                this.sides[this.activeSideIndex].x2 -= positionStep;
            },
            increaseY2: function (e) {
                this.sides[this.activeSideIndex].y2 += positionStep;
            },
            decreaseY2: function (e) {
                this.sides[this.activeSideIndex].y2 -= positionStep;
            },
            calculateY2: function (side) {
                return side.y + side.fontSize1;
            },
            setToMiddle: function () {
                this.sides[this.activeSideIndex].x =
                    this.sides[this.activeSideIndex].blockPrintZone.middleX;
                this.sides[this.activeSideIndex].y =
                    this.sides[this.activeSideIndex].blockPrintZone.middleY + (document.getElementById('text1').clientHeight / 4);
            },
            setToMiddle2: function () {
                this.sides[this.activeSideIndex].x2 =
                    this.sides[this.activeSideIndex].blockPrintZone.middleX;
                this.sides[this.activeSideIndex].y2 =
                    this.sides[this.activeSideIndex].blockPrintZone.middleY + (document.getElementById('text2').clientHeight / 4);
            },
            addQuantity: function (count) {
                if(this.count < this.activeProduct.maximumAmount) {
                    this.count = parseInt(this.count) + parseInt(count);
                }
            },
            removeQuantity: function (count) {
                if (this.count > 1) {
                    this.count = this.count - parseInt(count);
                }
            },
            startPolling: function (method) {
                if (typeof method === "function") {
                    if (!this.polling) {
                        method();
                        this.polling = setInterval(() => method(), pollingRate);
                    }
                }
            },
            stopPolling: function () {
                if (this.polling) {
                    clearInterval(this.polling);
                    this.polling = false;
                }
            },
            handleSubmit: function (e) {
                e.preventDefault();

                var dto = JSON.parse(JSON.stringify(this.sides));
                var result = dto.map((side, idx) => {
                    // console.log("side", side);
                    var img = this.findSideColor(idx, this.activeProductColorIndex);
                    return {
                        printColor: side.activePrintColor,
                        font1: side.font1,
                        font2: side.font2,
                        fontSize1: side.fontSize1,
                        fontSize2: side.fontSize2,
                        text1: side.text1,
                        text2: side.text2,
                        x: side.x,
                        y: side.y,
                        x2: side.x2,
                        y2: side.y2,
                        blockName: side.blockName,
                        blockPrintZone: side.blockPrintZone,
                        image: {
                            width: parseInt(img.width),
                            height: parseInt(img.height),
                            src: img.itemImageFull,
                        },
                    };
                });

                var variantTitle = find(this.variants, {
                    id: parseInt(this.activeVariantId),
                }).title;
                var colorId = this.productColors[this.activeProductColorIndex].id;
                var tmp = window.data.variants.filter(
                    (x) => x.title == variantTitle && x.colorId == colorId
                )[0];

                var extraList = [];
                this.extras.forEach(k => {
                    if (k.active) {
                        extraList.push({
                            id: k.defaultVariantId,
                            text: k.text
                        });
                    }
                });

                window.cart.addToCart(
                    Object.assign(tmp, JSON.parse(productData)),
                    this.count,
                    extraList,
                    result,
                    this.productRemark,
                    null
                );
                window.openCartPopup();
                window.scrollTo(0, 0);

                this.$refs.productForm.reset();
            }
        },
        watch: {
            activeProductColorIndex: function (newValue) {
                this.activeSideProductColor = this.findSideColor(this.activeSideIndex, newValue);
                // Set active variant for color
                this.activeProduct = this.findActiveVariant(this.activeVariantId, newValue);
                if (!this.activeProduct) {
                    this.activeProduct = this.findFirstVariantByColor(newValue);
                }
                this.activeVariantId = this.activeProduct.id;
            },
            activeVariantId: function (newValue) {
                // Active product set
                this.setActiveVariant(newValue);
            },
            sides: {
                deep: true,
                handler: debounce(function () {
                    changeCount++;
                    this.checkSizeConstraints();
                }, 500),
            },
        },
    });
}
